import React, { useEffect } from 'react'
import Button from '../../../components/ButtonNew'
import ArrowRightIcon from '../../../assets/icons/common/arrow-right.svg'
import moveToStore from '../../../utils/helpers/deviceType'
import Layout from '../../../components/Layout'
import Text from '../../../components/Text'

import Lottie from 'react-lottie'
import * as successTickAnimationData from '../../../assets/animations/success-tick.json'
import MySaathiLogo from '../../../assets/images/sema-onboarding/mysaathi-logo.webp'
import AppScreenshot from '../../../assets/images/sema-onboarding/app-screenshot.webp'
import PageFooter from './PageFooter'
import { getUrlParams } from '../../../utils/helpers/common'
import { trackEvent } from '../../../analytics'
import { EVENTS } from '../../../analytics/events'

const SignupSuccess = () => {
  useEffect(() => {
    const urlParams = getUrlParams()
    localStorage.removeItem('auth_token')
    trackEvent(EVENTS.MY_SAATHI_REGISTRATION_SUCCESS, {
      screenName: 'welcome page',
      ...urlParams,
    })
  }, [])

  const handleDownloadClick = () => {
    // window.open('https://goodflip.com', '_blank')
    console.log('download')
    moveToStore('https://dl.mytatva.in')
  }

  const successTickAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: successTickAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <Layout>
      <div className="min-w-sm max-w-lg relative mx-auto w-full h-screen overflow-y-auto bg-[linear-gradient(0deg,_#FFF_60%,_#D1FADF_100%)] flex flex-col items-center">
        <div className="relative w-full h-full top-20 z-0 px-4">
          <div className="absolute -top-14 left-0 right-0 bg-white shadow-md z-10 rounded-full w-[100px] h-[100px] mx-auto flex items-center justify-center">
            <Lottie
              options={successTickAnimationOptions}
              height={100}
              width={100}
            />
          </div>
          <div className="flex flex-col z-10 p-4 bg-white rounded-xl overflow-hidden space-y-5">
            {/* Header section */}
            <div className="flex flex-col items-center justify-center">
              <Text
                variant="title"
                size="large"
                tag="h2"
                className="text-[#101828] mt-14 px-4"
                textalign="center"
              >
                Welcome to
              </Text>
              <img
                src={MySaathiLogo}
                className="object-scale-down mt-2"
                width={183}
                alt="woman-thumbs-up"
              />
            </div>

            {/* Body section */}
            <div className="flex flex-col items-center justify-center">
              <Text variant="label" size="medium" tag="p" textalign="center">
                We have verified your phone number.
              </Text>
              <Text
                variant="label"
                size="medium"
                tag="p"
                className="mt-5"
                textalign="center"
              >
                Complete your registration to access your personalized benefits.
              </Text>
            </div>

            {/* Download button section */}
            <div className="-mx-4 pt-3">
              <img
                src={AppScreenshot}
                alt="app-screenshot"
                className="object-scale-down w-44 h-32 mx-auto -mb-11"
              />
              <div className="relative bg-[#E6FAF1] rounded-2xl py-3 px-4">
                <Button size="xSmall" fullWidth onClick={handleDownloadClick}>
                  Download GoodFlip App
                  <img src={ArrowRightIcon} alt="arrow-right" />
                </Button>
                <Text
                  variant="label"
                  size="xSmall"
                  tag="p"
                  textalign="center"
                  className="text-[#667085] mt-3"
                >
                  You can complete registration anytime from the app
                </Text>
              </div>
            </div>

            {/* Footer section */}
            <span className="flex-1" />
            <PageFooter />
          </div>
        </div>
        {/* Bottom fixed button  */}
      </div>
    </Layout>
  )
}

export default SignupSuccess
